import Selection from "./selection";
import {FlashOperationTypes, ActionTypeEnum} from "../base/training-literals";

class Flash extends Selection {
    highlightData;
    transparencyData;
    visibilityData;
    flashList;
    intervalId;
    constructor(props) {
        super(props);
        this.interval = props.interval || 1000;
        this.duration = props.duration || props.timeLineDuration;
        this.generateSelectionData();
        this.stop = this.stop.bind(this);
        document.addEventListener('training_stopped_abruptly', this.stop);
    }

    generateSelectionData() {
        const getData = (type) => {
            return {
                models: this.models.filter(model => model.flashOperationType === type),
                volumes: this.volumes.filter(volume => volume.flashOperationType === type),
                branches: this.branches.filter(branch => branch.flashOperationType === type),
                groups: this.groups.filter(group => group.flashOperationType === type)
            };
        };

        const isValidData = (data) => {
            return data.models.length > 0 || data.volumes.length > 0 || data.branches.length > 0 || data.groups.length > 0;
        };

        for (const operationType of FlashOperationTypes) {
            const data = getData(operationType);
            if (!isValidData(data)) {
                continue;
            }

            switch (operationType) {
                case ActionTypeEnum.HIGHLIGHT:
                    this.highlightData = data;
                    this.highlightData.resetValue = false;
                    this.highlightData.enabled = this.highlightData.resetValue;
                    this.highlightData.showTooltip = false;
                    break;
                case ActionTypeEnum.VISIBILITY:
                    this.visibilityData = data;
                    this.visibilityData.resetValue = true;
                    this.visibilityData.enabled = this.visibilityData.resetValue;
                    break;
                case ActionTypeEnum.TRANSPARENCY:
                    this.transparencyData = data;
                    this.transparencyData.resetValue = false;
                    this.transparencyData.enabled = this.transparencyData.resetValue;
                    break;
                default:
                    break;
            }

        }
    }

    async execute({training}) {
        const modelIds = new Set();

        for (let model of this.models) {
            const modelResource = training.resources[model.id];
            modelIds.add(modelResource?.resourceId || (modelResource?.type === ResourceTypeEnum.HELPER_OBJECT && modelResource?.id));
        }

        for (let volume of this.volumes) {
            modelIds.add(modelManager.getModelIdByBranchId(volume.id));
        }

        for (let branch of this.branches) {
            const branchNode = MeshHierarchyViewFeatureData.getDataFromBranchID(branch.id);
            modelIds.add(branchNode.modelId);
        }

        for (let group of this.groups) {
            modelIds.add(GroupData.getModelIdFromGroupId(group.id));
        }

        //stop GLB animations for models
        for (let modelId of modelIds) {
            const modelObj = modelManager.getModelById(modelId);
            if (modelObj) {
                await modelObj.animationController.stopAnimation();
            }
        }
        await this.performFlash();
    }

    resetFlash() {
        this.flashList.forEach(flash => {
            if (flash.data.enabled === flash.data.resetValue) {
                return;
            }

            flash.data.enabled = flash.data.resetValue;
            flash.operation(flash.data);
        });
    }

    async stop() {
        if (!this.intervalId) {
            return;
        }

        clearInterval(this.intervalId);
        this.resetFlash();
    }

    async performFlash() {
        await updateFlashSelectionMaterial(false);
        this.flashList = [];
        if (this.highlightData) {
            this.flashList.push({operation: performHighlight, data: this.highlightData});
        }

        if (this.visibilityData) {
            this.flashList.push({operation: performVisibility, data: this.visibilityData});
        }

        if (this.transparencyData) {
            this.flashList.push({operation: performTransparency, data: this.transparencyData});
        }

        if (!this.flashList.length) {
            return;
        }

        this.flashList.forEach(flash => {
            flash.data.enabled = !flash.data.enabled;
            flash.operation(flash.data);
        });

        const startTime = Date.now();
        this.intervalId = setInterval(async () => {
            const elapsedTime = Date.now() - startTime;
            if (elapsedTime >= this.duration) {
                await this.stop();
                return;
            }
            this.flashList.forEach(flash => {
                flash.data.enabled = !flash.data.enabled;
                flash.operation(flash.data);
            });

        }, this.interval);

        setTimeout(() => this.stop(), this.duration);
    }

}

export default Flash;
